var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsseta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 329 45.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5d4e40;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "base"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.41,39.11a40.3,40.3,0,0,1,4.12-7.22,67.83,67.83,0,0,1,5.24-6.51,75.45,75.45,0,0,1,12.74-10.95A82.88,82.88,0,0,1,264.77,1.54a88.16,88.16,0,0,1,33.65.16A83.73,83.73,0,0,1,329,14c-2.79,0-5.49-.26-8.16-.47-1.35-.05-2.68-.15-4-.22s-2.63-.24-3.95-.25L309,12.9c-.66,0-1.3-.1-1.95-.11l-1.95,0c-1.3,0-2.59-.07-3.87-.12s-2.57,0-3.85,0a161.87,161.87,0,0,0-29.94,2.65A138.6,138.6,0,0,0,238.84,24,159.47,159.47,0,0,0,211.41,39.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,13.75A40,40,0,0,1,7,9.22a66.93,66.93,0,0,1,7.64-3.39A75.44,75.44,0,0,1,31,1.93,82.68,82.68,0,0,1,64.64,4.81,88.07,88.07,0,0,1,94.47,20.37a83.77,83.77,0,0,1,21.53,25c-2.46-1.31-4.75-2.75-7-4.16-1.18-.66-2.32-1.35-3.46-2s-2.23-1.42-3.41-2l-3.41-2c-.57-.31-1.11-.67-1.68-1l-1.72-.93c-1.15-.6-2.26-1.25-3.38-1.88s-2.31-1.14-3.43-1.75A160.9,160.9,0,0,0,60.66,18.23,138,138,0,0,0,31.29,12.9,159,159,0,0,0,0,13.75Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsseta);
export default __webpack_public_path__ + "static/media/Asset a.7b04b95b.svg";
export { ForwardRef as ReactComponent };